/* eslint-disable no-unused-vars */

import _ from 'lodash';
export const checkValueInObjectIsNotEmpty = (data = {}) => {
  if (
    !_.isEmpty(
      Object.values(data)?.filter((x) =>
        _.isString(x) && !_.isEmpty(x) ? x : _.isArray(x?.value) && !_.isEmpty(x?.value) ? x : null
      )
    )
  )
    return true;
  else return false;
};

export const extractVisibleTextFromHTMLString = ({ htmlString }) => {
  if (htmlString) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Remove script and style elements
    tempDiv.querySelectorAll('script, style').forEach((el) => el.remove());

    // Remove hidden elements (display:none, visibility:hidden)
    tempDiv.querySelectorAll('*').forEach((el) => {
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') {
        el.remove();
      }
    });

    // Get text and normalize spaces
    return tempDiv.textContent
      .replace(/\s+/g, ' ') // collapse multiple spaces/newlines/tabs into one
      .trim(); // remove leading/trailing spaces
  } else {
    return '';
  }
};

export const dropdownMenuMap = ({ inspection }) => {
  const {
    pipelineCathodicProtection = [],
    pipelineAssignedBatchingInterval = [],
    pipelineAssignedPiggingInterval = [],
    pipelineStatus = [],
    externalProtection = [],
    internalProtection = [],
    material = [],
    operationsArea = [],
    pipelineReceiverType = [],
    pipelineSenderType = [],
    substance = [],
    pipelineType = [],
    province = [],
    siteStatus = [],
    codeOfConstruction = [],
    areaHierarchy = [],
    equipmentCategoryTypeSubtype = [],
    service = [],
    equipmentStatus = [],
    pSVType = [],
    equipmentValveLocation = [],
    capacity = [],
    concentrationUnits = [],
    largeMeasurement = [],
    smallMeasurement = [],
    pressure = [],
    temperature = [],
    timeUnit = [],
    volume = [],
    pipelineArea = [],
    passFailList = [],
    passDeficiencyFail = [],
    equipmentCategory = [],
    flowRate = [],
    condition = [],
    siteType = [],
    cylinderType = [],
    structureType = [],
    gaugeBoardUOM = [],
    equipmentInsulationMaterial = [],
    constructionMaterial = [],
    psvCategoryTypeAndSubType = [],
    equipmentConnectionType,
    HSEProactiveEffortType = [],
    HSEFocusAreas = [],
    HSEVendors = [],
    functionalGroup = [],
    species = [],
    wildlifeIncidentType = [],
    incidentStatus = [],
    inspectionFrequency = [],
    usersNamesList = [],
    orientationType = [],
    cMLComponent = [],
    cMLLocation = [],
    ultrasonicTestingCMLSchedule = [],
    smallMeasurementAllowed = [],
    aNSIRating = [],
    pSVDischargesTo = []
  } = inspection;

  let SmallMeasurementPickListForCML = smallMeasurement
    ?.filter((x) => ['in', 'mm'].includes(x?.lookupValue))
    ?.map((x) => {
      return {
        label: x?.lookupValue,
        value: x?.value
      };
    });

  let list = [];
  list = equipmentCategoryTypeSubtype;

  let dropdownMenuMap = {
    PSVDischargesToPickList: pSVDischargesTo,
    ANSIRatingPickList: aNSIRating,

    CMLComponentPickList: cMLComponent,
    CMLLocationPickList: cMLLocation,
    UltrasonicTestingCMLSchedulePickList: ultrasonicTestingCMLSchedule,

    InspFrequencyList: inspectionFrequency,
    PipelineCathodicProtectionPickList: pipelineCathodicProtection,
    ExternalProtectionPickList: externalProtection,
    PipelineAssignedBatchingIntervalPickList: pipelineAssignedBatchingInterval,
    PipelineAssignedPiggingIntervalPickList: pipelineAssignedPiggingInterval,
    PipelineAreaList: areaHierarchy,
    InternalProtectionPickList: internalProtection,
    OperationsAreaPickList: operationsArea,
    MaterialsPickList: material,
    PipelineReceiverTypePickList: pipelineReceiverType,
    PipelineSenderTypePickList: pipelineSenderType,
    PipelineTypePickList: pipelineType,
    PipelineStatusPickList: pipelineStatus,
    SubstancesPickList: substance,
    ProvincesPickList: province,
    SiteTypePickList: siteType,
    AreaList: areaHierarchy,
    SiteStatusPickList: siteStatus,
    EquipmentValveLocationPicklist: equipmentValveLocation,
    ServicesPickList: service,
    EquipmentStatusPickList: equipmentStatus,
    PSVTypePickList: pSVType,
    CodeOfConstructionPickList: codeOfConstruction || [],
    // EquipmentCategoryTypeSubtypePickList: equipmentCategoryTypeSubtype,
    CapacityPickList: capacity,
    ConcentrationUnitsPickList: concentrationUnits,
    LargeMeasurementPickList: largeMeasurement,
    SmallMeasurementPickList: smallMeasurement,
    SmallMeasurementAllowedPickList: smallMeasurement?.filter((x) => x?.smallMeasurementAllowed),
    PressurePickList: pressure,
    TemperaturePickList: temperature,
    TemperaturePicklist: temperature,
    TimeUnitPickList: timeUnit,
    VolumePickList: volume,
    VolumePicklist: volume,
    InspResult_PassFailList: passFailList,
    InspResult_PassDeficiencyFailList: passDeficiencyFail,
    EquipmentCategoryTypeSubtypePickList: list || [],
    FlowRate: flowRate,
    ConditionPickList: condition,
    FlowRatePickList: flowRate,
    CylinderTypePickList: cylinderType,
    ConstructionMaterialPickList: constructionMaterial,
    StructureTypePickList: structureType,
    GaugeBoardUOM: gaugeBoardUOM,
    EquipmentInsulationMaterialPickList: equipmentInsulationMaterial,
    PsvCategoryTypeAndSubTypePickList: psvCategoryTypeAndSubType,
    EquipmentConnectionTypePickList: equipmentConnectionType,
    VendorList: HSEVendors,
    FocusAreasList: HSEFocusAreas,
    FuncGroupList: functionalGroup,
    SpeciesList: species,
    ProactiveEffortTypesList: HSEProactiveEffortType,
    Sighting: wildlifeIncidentType,
    Encounter: wildlifeIncidentType,
    UserList: usersNamesList,
    OrientationTypePickList: orientationType,

    SmallMeasurementPickListForCML: SmallMeasurementPickListForCML,
    SmallMeasurementPickListForCMLFirst: SmallMeasurementPickListForCML?.filter(
      (x) => x?.label === 'in'
    )
  };
  return dropdownMenuMap;
};
